import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react';
import { FigureOverlay, ModelLoading } from '../../components/';
import { Center, ContactShadows, OrbitControls } from '@react-three/drei';
import { theme } from '../../theme';
import { useState, useRef, forwardRef, useEffect } from 'react';
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three'

const Model = forwardRef((props, ref) => {
  const { glbPath, rotateX, scaleFactor } = props;
  const { scene } = useGLTF(glbPath);

  useEffect(() => {
    if (scene && rotateX) {
      scene.rotation.x = -Math.PI / 2;
    }
    if (scene && scaleFactor) {
      scene.scale.set(scaleFactor, scaleFactor, scaleFactor);
    }
  }, [scene, glbPath, rotateX, scaleFactor]);
  return (
    <group {...props} ref={ref}>
      {scene && <primitive object={scene} position={[0,0,0]}/>}
    </group>
  );
});

const Scene = ({ asset, center = true, rotateX = false, scaleFactor = null }) => {
  return (
    <>
      <ambientLight intensity={0.5} />
      <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={2048} castShadow />
      <Suspense fallback={<FigureOverlay customStyle={{top: '-50px', left: '-120px'}}><ModelLoading /></FigureOverlay>}>
        {center ?  (
          <Center>
            <Model glbPath={asset.getGlbSource()} rotateX={rotateX} scaleFactor={scaleFactor}/>
            <ContactShadows position={[0, 0, 0]} opacity={0.75} scale={10} blur={2.5} far={4} />
          </Center>
        ) : (
          <>
            <Model glbPath={asset.getGlbSource()}/>
            <ContactShadows position={[0, 0, 0]} opacity={0.75} scale={10} blur={2.5} far={4} />
          </>
        )}
      </Suspense>
    </>
  );
}

export default function AssetView({ asset }) {
  const [dragging, setDragging] = useState(false);

  const isArmorOrClothing = asset.nftData.type === 'armor' ||
    (asset.nftData.type === 'object' &&
     asset.nftData.subtype !== 'equip' &&
     asset.nftData.subtype !== 'shield' &&
     !asset.nftData.subtype.startsWith('drone'));
     
  const controlsRef = useRef(null);

  const cameraPosition = isArmorOrClothing ? [0, 1, -8] : [0, 0, 3.25];
  const setupCamera = (camera) => {
    const target = new THREE.Vector3(0, 1, 0);
    if (isArmorOrClothing) {
      controlsRef.current.target = target;
    }
  };

  const rotateObject = !isArmorOrClothing && !asset.nftData.subtype.startsWith('drone');
  const scaleFactor = asset.nftData.subtype?.includes('mutatio') ? 10 : null;
  return (
    <div style={{cursor: dragging ? 'grabbing' : 'grab', position: 'relative', width: '100%', height: '100%'}} onMouseDown={() => setDragging(true)} onMouseUp={() => setDragging(false)}>
      <Canvas onCreated={(state) => setupCamera(state.camera)} style={{ backgroundColor: 'transparent', width: '100%', height: '100%' }} shadows camera={{position: cameraPosition, fov: 15 }}>
        <Scene asset={asset} center={!isArmorOrClothing} rotateX={rotateObject} scaleFactor={scaleFactor}/>
        <OrbitControls ref={controlsRef} minDistance={2} maxDistance={10}/>
      </Canvas>
      <div style={{ position: 'absolute', right: '8px', bottom: '0px', width: '40px'}}>
        <div style={{fontFamily: 'NeueMachina', fontWeight: '800', color: theme.buttonLightBlue, fontSize: '1.25rem', width: '100%', textAlign: 'center'}}>3D</div>
        <img src='/assets/icon_3d.svg' style={{width: '100%', paddingTop: '4px'}}/>
      </div>
    </div>
  );
}
